<template>
  <transition
    enter-active-class="animated fadeIn"
    leave-active-class="animated fadeOut"
    tag="div"
  >
    <div class="message-push" v-if="!redaState && messageInfo">
      <div class="modal-content">
        <div class="modal-head">
          <img src="@/assets/img/clsicon.png" @click="redaState = true" />
        </div>
        <div class="modal-body">
          <p>{{ messageInfo.title }}</p>
          <p class="message-info">{{ messageInfo.description }}</p>
          <button class="detail-btn" type="button" @click="lookDetail">
            {{ $t("courseCentreDetail.details") }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      messageInfo: null,
      redaState: false,
    };
  },
  computed: {
    ...mapState({
      clearPush: (state) => state.message.clearPush,
    }),
  },
  activated() {
    if (this.clearPush) {
      this.messageInfo = null;
      this.redaState = false;
      this.setClearPush(false);
    }
    if (this.messageInfo === null) {
      this.messagePush();
    }
  },
  methods: {
    ...mapMutations("message", ["setClearPush"]),
    // 消息推送通知
    messagePush() {
      this.$axios
        .post(`index.php/mobile/message/sys-list`, {
          is_read: 0,
          pop_up: 1,
          page: 1,
          size: 1,
        })
        .then((res) => {
          if (res.data.result && res.data.result.data.length > 0) {
            this.messageInfo = res.data.result.data[0];
          }
        });
    },
    // 查看消息详情
    lookDetail() {
      this.redaState = true;
      this.$router.push({
        path: "/main/message_detail",
        query: { id: this.messageInfo.id },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.animated {
  animation-duration: 0.3s;
}
.message-push {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.7);
  .modal-content {
    width: 85%;
    position: absolute;
    top: 50%;
    left: 7.25%;
    background: white;
    border-radius: 0.14rem;
    transform: translateY(-50%);
    overflow: hidden;
  }
  .modal-head {
    height: 0.6rem;
    background: #f6f6f6;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    img {
      width: 0.24rem;
      margin-right: 0.23rem;
    }
  }
  .modal-body {
    padding: 0.3rem 0.3rem 0.44rem;
    text-align: center;
    P:first-child {
      font-size: 0.3rem;
      color: #252631;
      margin-bottom: 0.15rem;
    }
    .message-info {
      font-size: 0.28rem;
      text-align: left;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      /*autoprefixer: on */
    }
    .detail-btn {
      padding: 0.1rem 0.24rem;
      margin-top: 0.3rem;
      border-radius: 0.1rem;
      border: none;
      // background: @primary-color;
      color: white;
      font-size: 0.28rem;
      outline: none;
    }
  }
}
</style>
